import type { LabelColor } from "./types";

export const LABEL_COLORS: Record<
  LabelColor,
  { name: string; bgClassName: string; textClassName: string }
> = {
  quaternary: {
    name: "Grey",
    bgClassName: "bg-black-200",
    textClassName: "text-black-500",
  },
  secondary: {
    name: "Purple",
    bgClassName: "bg-purple-200",
    textClassName: "text-purple-500",
  },
  danger: {
    name: "Red",
    bgClassName: "bg-red-200",
    textClassName: "text-red-500",
  },
  yellow: {
    name: "Yellow",
    bgClassName: "bg-yellow-200",
    textClassName: "text-yellow-500",
  },
  info: {
    name: "Blue",
    bgClassName: "bg-blue-200",
    textClassName: "text-blue-500",
  },
  success: {
    name: "Green",
    bgClassName: "bg-green-200",
    textClassName: "text-green-500",
  },
  orange: {
    name: "Orange",
    bgClassName: "bg-orange-200",
    textClassName: "text-orange-500",
  },
  magenta: {
    name: "Magenta",
    bgClassName: "bg-magenta-200",
    textClassName: "bg-magenta-500",
  },
} as const;
